/**
 * 检测是否支持webp格式
 */
function checkSupportsWebp() {
  try {
    return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0
  } catch (err) {
    return false
  }
}
/**
 * 传入图片链接，判断是否CDN图片
 * @param {String} imgUrl 图片链接
 * @returns {Boolean} 是否CDN图片
 */
function checkIsCDNImg(imgUrl) {
  imgUrl = imgUrl || ''
  var isCDNImg =
    (imgUrl.indexOf('http') === 0 || imgUrl.indexOf('//') === 0) &&
    imgUrl.indexOf('cdn.') > -1 &&
    imgUrl.indexOf('kefucdn.') == -1 &&
    imgUrl.indexOf('videocdn.') == -1
  return isCDNImg
}
/**
 * 传入图片链接，判断是否符合转换webp的要求
 * @param {String} imgUrl 图片链接
 * @returns {Boolean} 是否符合转换webp的要求
 */
function checkImgValidForWebp(imgUrl) {
  imgUrl = imgUrl || ''
  var isCDNImg = checkIsCDNImg(imgUrl)
  var isGif = imgUrl.indexOf('.gif') > -1 //gif图片不进行转换，因为可能变得更大
  return isCDNImg && !isGif
}
/**
 * 传入图片链接，根据是否支持webp返回图片链接
 * @param {String} imgUrl 图片链接
 * @returns {String} 处理后的图片链接
 */
export function getImgUrlByWebpSupport(imgUrl) {
  imgUrl = imgUrl || ''
  const supportsWebp = checkSupportsWebp() // 是否支持webp
  var isImgValidForWebp = checkImgValidForWebp(imgUrl)
  var imgUrlArr = imgUrl.split('?')
  var resImgUrl = imgUrl
  if (isImgValidForWebp && supportsWebp) {
    // 支持展示webp，拼接参数
    resImgUrl =
      imgUrlArr[0].indexOf('/format/webp') == -1
        ? imgUrlArr[0] + (imgUrlArr[0].indexOf('!') == -1 ? '!' : '') + '/format/webp' + (imgUrlArr[1] ? '?' + imgUrlArr[1] : '') //问号后的参数放到最后
        : imgUrl
  } else {
    // 不支持展示webp，恢复原图链接
    resImgUrl = imgUrl.indexOf('/format/webp') > -1 ? restoreImgUrlFromWebp(imgUrl) : imgUrl
  }
  return resImgUrl
}
/**
 * 传入webp图片链接，将其转回普通图片
 * @param {String} imgUrl 图片链接
 * @returns {String} 处理后的图片链接
 */
export function restoreImgUrlFromWebp(imgUrl) {
  imgUrl = imgUrl || ''
  var imgUrlArr = imgUrl.split('?')
  imgUrlArr[0] = imgUrlArr[0].replace(/\/format\/webp/g, '')
  if (imgUrlArr[0][imgUrlArr[0].length - 1] === '!') {
    // 去除结尾的!符号，
    imgUrlArr[0] = imgUrlArr[0].slice(0, -1)
  }
  var resImgUrl = imgUrlArr[0] + (imgUrlArr[1] ? '?' + imgUrlArr[1] : '')
  return resImgUrl
}
/**
 * 传入图片链接获取picture标签处理后的html
 * @param {String} imgUrl 图片链接
 * @param {Boolean} isLazy 是否懒加载（仅适用懒加载属性为data-src的情况）
 * @param {Boolean} autoWidth 是否自适应宽度
 * @param {Boolean} isFullWidth 当前图片是否占据页面全部大小，默认为false，仅在autoWidth=true时有效
 * - 注意在page内部的绝大部分元素会受限于page的最大宽度750px，非平板模式下一般只有浮层之类的元素可以占据页面全部大小
 * @param {String} fallbackHtml 保底元素html，默认会使用传入的imgUrl生成img标签，当需要保留一些属性时（如class、id等）可以传入
 * @returns {String} 处理后的html
 */
export function getPictureHtmlByImg(imgUrl, isLazy, autoWidth, isFullWidth, fallbackHtml) {
  imgUrl = imgUrl || ''
  // 转webp格式图片（仅针对cdn图片）
  imgUrl = imgUrl.replace(/^https?:/i, '') //去除协议头防止协议不同无法加载
  var isImgValidForWebp = checkImgValidForWebp(imgUrl) //若图片不符合要求，将继续使用img标签，不使用picture标签包裹
  var webpUrl = getImgUrlByWebpSupport(imgUrl, true)
  fallbackHtml = fallbackHtml || '<img ' + (isLazy ? 'data-src' : 'src') + '="' + imgUrl + '">'
  var imgHtml = isImgValidForWebp
    ? '<picture>' +
      '<source ' +
      (isLazy ? 'data-srcset' : 'srcset') +
      '="' +
      (autoWidth
        ? webpUrl +
          '/fw/375 375w,' +
          webpUrl +
          '/fw/750 750w,' +
          // webpUrl +
          // '/fw/1125 1125w,' +
          // webpUrl +
          // '/fw/1500 1500w,' +
          webpUrl +
          '/fw/1875 1875w,' +
          webpUrl +
          '/fw/2250 2250w,'
        : '') +
      webpUrl +
      '" type="image/webp" ' +
      (autoWidth ? 'sizes="' + (isFullWidth ? '' : '(min-width: 750px) 750px,') + '100vw"' : '') +
      '>' +
      fallbackHtml +
      '</picture>'
    : fallbackHtml
  return imgHtml
}
/**
 * 根据是否支持webp，将html中的图片做转换处理
 * @param {String} imgHtml 待处理的html
 * @param {Boolean} autoWidth 是否自适应宽度（不建议用在有图片放大的场景，因为自适应分辨率会导致picture中的img标签naturalWidth/naturalHeight不准）
 * @param {Boolean} isFullWidth 当前图片是否占据页面全部大小，默认为false，仅在autoWidth=true时有效，用于getPictureHtmlByImg方法
 * @param {Boolean} pureImgMode 【注：在后台可能无法正常渲染picture，所以必须开启此模式】纯img模式，不使用picture包裹，直接将img的url替换为webp。适用于不适合使用picture标签的场景，如swiper内部。
 * - swiper中的图片如果使用picture标签，会因为内部的预加载逻辑仍然加载原图，导致重复加载，所以建议使用此方法。
 * @returns {String} 处理后的html
 */
export function transformImgHtmlByWebpSupport(imgHtml, autoWidth, isFullWidth, pureImgMode = true) {
  imgHtml = imgHtml || ''
  var tempDiv = document.createElement('div')
  //为防止此处赋值html时触发图片加载，将src属性暂时转换，后续再转回,css背景图没有这个问题所以无需处理
  tempDiv.innerHTML = imgHtml.replace(/src=/g, 'src_placeholder=')
  // img标签处理
  var imgList = tempDiv.querySelectorAll('img[src_placeholder], img[data-src_placeholder]')
  Array.prototype.forEach.call(imgList, function (item) {
    if (item) {
      // 提取图片链接
      var curSrc = item.getAttribute('src_placeholder')
      var lazySrc = item.getAttribute('data-src_placeholder')
      var isLazy = !curSrc && !!lazySrc //有src时则不视为懒加载
      if (pureImgMode) {
        // 纯img标签模式
        if (isLazy) {
          item.setAttribute('data-src_placeholder', getImgUrlByWebpSupport(lazySrc))
        } else {
          item.setAttribute('src_placeholder', getImgUrlByWebpSupport(curSrc))
        }
      } else {
        // 原地替换标签
        item.outerHTML = getPictureHtmlByImg(isLazy ? lazySrc : curSrc, isLazy, autoWidth, isFullWidth, item.outerHTML)
          .replace(/srcset=/g, 'srcset_placeholder=')
          .replace(/src=/g, 'src_placeholder=')
      }
    }
  })
  // css背景图处理
  var backgroundImageList = tempDiv.querySelectorAll('[style]')
  Array.prototype.forEach.call(backgroundImageList, function (item) {
    if (item && item.style && item.style.backgroundImage) {
      // 使用正则表达式匹配图片链接
      var regex = /url\(["']?(.*?)["']?\)/i
      var match = item.style.backgroundImage.match(regex)
      if (match && match[1]) {
        var imgUrl = match[1]
        item.style.backgroundImage = 'url("' + getImgUrlByWebpSupport(imgUrl) + '")'
      }
    }
  })
  imgHtml = tempDiv.innerHTML.replace(/srcset_placeholder=/g, 'srcset=').replace(/src_placeholder=/g, 'src=')
  tempDiv = null
  return imgHtml
}
// 移除空节点
function removeEmptyNodes(html) {
  return html.replace(/<([a-zA-Z]+)(\s[^>]*)?>\s*(?:&nbsp;|\s)*<\/\1>/g, '')
}
/**
 * 根据是否支持webp，将html中的图片做转换处理,并根据段落进行截断
 * @param {String} imgHtml 待处理的html
 * @returns {String} 处理后的html
 */
export function transformImgHtmlByWebpSupportAndLimitHtml(imgHtml, autoWidth, isFullWidth, pureImgMode = true) {
  imgHtml = transformImgHtmlByWebpSupport(imgHtml, autoWidth, isFullWidth, pureImgMode)
  // 检查是否存在 <h4> 标签

  // 检查是否存在 <h4> 标签
  if (/<h4[^>]*>.*?<\/h4>/i.test(imgHtml)) {
    // 移除空的 <h4> 标签
    imgHtml = imgHtml.replace(/<h4[^>]*>\s*(?:&nbsp;|\s)*<\/h4>/gi, '')

    // 捕获所有 <h4> 标签及后续内容为一组
    let sections = imgHtml.match(/<h4[^>]*>.*?(?=<h4[^>]*>|$)/gis) || []

    // 重新构建内容
    let processedContent = sections
      .map((section) => {
        // 移除空节点
        section = removeEmptyNodes(section)

        // 包裹成段落
        return `<div class="paragraph-custom">
        <div class="edit-opea-btn edit-content-opea-btn">
          <ehf-icon icon="edit-box-line" style="margin-right: 5px"></ehf-icon>编辑
        </div>
        ${section}
      </div>`
      })
      .join('')

    return processedContent
  } else {
    // 无 <h4> 标签的情况
    return `<div class="paragraph-custom no-bg">
    <div class="edit-opea-btn edit-content-opea-btn">
      <ehf-icon icon="edit-box-line" style="margin-right: 5px"></ehf-icon>编辑
    </div>
    ${imgHtml}
  </div>`
  }
}
